/**
 *
 {
 Rome: [{
     city_cn: "羅馬",
     city_en: "Rome",
     contentId: "4riewpri49324343245",
     country_cn: "意大利",
     country_en: "Italy",
     latitude: 41.9028,
     longitude: 12.4964
     },{
     city_cn: "羅馬",
     city_en: "Rome"
     contentId: "5oooriewpri49324343245",
     country_cn: "意大利",
     country_en: "Italy",
     latitude: 41.8719,
     longitude: 12.5674
 }],
 Paris: [{
     city_cn: "巴黎",
     city_en: "Paris",
     contentId: "6riewpri49324343245",
     country_cn: "法國",
     country_en: "France",
     latitude: 48.8566,
     longitude: 2.3522
 }]
 }
 */

let locationStore = {};

export function set(_location) {
    locationStore = _location;
}

export function get() {
    return locationStore;
}
